export const Strings = {
  auth: {
    skip: "Skip",
    logIn: "Sign In",
    forgotPassword: "Forgot Password?",
    doNotHave: "Don’t have an account?",
    signUp: "Sign up",
    forgotPasswordPage: "Forgot Password",
    updatePassword: "Update Password",
    enterEmailTo: "Enter email to change your password",
    emailAddress: "Email Address",
    password: "Password",
    alreadyHaveIn: "Already have an account?",
    conformNewPassword: "Confirm New Password",
    firstName: "FirstName",
    lastName: "LastName",
    email: "Email",
    name: "Name",
    phone: "Phone",
    newPassword: "New Password",
    yourNewPassword:
      "Your new password must be different from previous used passwords.",
    conformPassword: "conform password",
  },
  myProfile: {
    editProfile: "Edit Profile",
    mobileNumber: "Mobile Number",
  },
  common: {
    hyphen: "-",
    kaizenMotor: " Kaizen Motor",
    logOut: "Log Out",
    changeLocation: "Change Location",
    pageNotFound: "Page not found!",
    sorryCanNotFoundPage:
      "Sorry, we couldn’t find the page you’re looking for.",
    success: "Success!",
    role: "Role",
    assignCustomer: "Assign Customer",
    failed: "Failed !",
    selected: (prefix: string) => (prefix ? `${prefix} selected` : "selected"),
    noRecord: "No Record",
    edit: "Edit",
    parentCategory: "Parent Category",
    addNewCategory: "Add New Category",
    addNewLocation: "Add New Location",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    addParentCategory: "Add Parent Category",
    search: "Search",
    addNewProduct: "Add new Product",
    addProducts: "Add Products",
    carDetails: "Car Details",
    showingEntries: "Showing 1 to 10 of 68 entries",
    projects: "Projects",
    allProjects: "All Projects",
    allStatus: "All Status",
    resetFilters: "Reset Filters",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    firstName: "First Name : ",
    lastName: "Last Name : ",
    phone: "Phone : ",
    email: "Email : ",
    statusHeading: "Status : ",
    city: "City : ",
    country: "Country : ",
    address: "Address : ",
    zipcode: "Zipcode : ",
    view: "View",
    close: "Close",
    goBack: "Go Back",
    print: "Print",
    selectAll: "Select All",
    addAnotherSpool: "Add Another Spool",
    dragAndDrop: "Drag & Drop or Choose File to import",
    selectProject: "Select Project :",
    selectLineNumber: "Select Line Number",
    saving: "Saving",
    confirm: "Confirm",
    assign: "Assign",
    clickToScan: "Click to Scan QR Code",
    send: "Send",
    na: "N/A",
    noBugFound: "No Bug Found",
    add: "Add",
    noQrGenerated: "No QR Generated",
    clickHere: "Click Here",
    lineId: "Line ID :",
    noRecordFound: "No record found",
  },
  salesPerson: {
    contact: "Phone",
    email: "Email",
    customersAssigned: "Assigned Customer",
    role: "Role",
    addSalesPerson: "Add User",
    editSalesPerson: "Edit User",
    dataNotFound: " No data found",
    deleteAssignedCustomer: "Delete Assigned Customer ?",
    areYouSure: "Are you sure you want to delete the Assigned Customer?",
    addCustomer: "Add Customer",
  },
  button: {
    details: "Details",
    confirmAndGenerate: "Confirm & Generate Code",
    addInventory: "Add Inventory",
    close: "Close",
    save: "Save",
    send: "Send",
    assignCustomer: "Assign Customer",
    selectCustomer: "Select Customer",
    addBrand: "Add Brand",
    addModel: "Add Model",
    edit: "Edit",
    changeStatus: "Change Status",
    valuation: "Add Car Valuation",
    salesPerson: "Assign SalesPerson",
    delete: "Delete",
    continue: "Continue",
    resetPassword: "Reset Password",
    conformBooking: "Confirm Booking",
    returnToHomePage: "Return to Homepage",
    back: "Back",
    payNow: "Pay Now",
    cancel: "Cancel",
    update: "Update",
    saveDetails: "Save Details",
    addCar: "Add Car",
    addMore: "Add More",
    sold: "Sold",
    addCustomer: "Add Customer",
  },
  users: {
    userManagement: "User Management",
    viewAndManage: "View and manage all user in the system.",
    status: "Status",
    addUser: "Add User",
    allRoles: "All Roles",
    estimator: "Estimator",
    detailer: "Detailer",
    fabShop: "Fab Shop",
    fieldInstaller: "Field Installer",
    welder: "Welder",
    areYouSure: "Are You Sure?",
    doYouWantToDelete: "Do You want to delete this user ?",
    enterYourPersonalEmail:
      "Enter your personal email address (not your work email).",
    officialEmailIsAuto:
      "Official Email is auto-generated and cannot be changed.",
    editUser: "Edit User",
  },
  purchaser: {
    addPurchaser: "Add Purchaser",
    purchaserManagement: "Purchaser Management",
    viewAndManage: "View and manage all purchaser in the system.",
    doYouWantDelete: "Do you want to delete this Purchaser",
  },
  addProducts: {
    specification: "Specification",
    addMore: "Add more",
    addNewLocation: "Add New Location",
    productImage: "Product Image",
    locations: "Locations",
    selectLocation: "Select Location",
  },
  rowActions: {
    edit: "Edit",
    delete: "Delete",
    view: "View",
  },
  header: {
    login: "Login",
  },
  validation: {
    fieldRequired: (field: string) => `Please enter the ${field}`,
    selectionRequired: (field: string) => `Please select the ${field}`,
    notAllowedWhiteSpace: (field: string) =>
      `${field} should not start with whitespace or be empty`,
    invalidEmail: "Please enter the valid email address",
    pleaseConfirmTheShipment: "Please Confirm the Shipment ",
    isRequired: (field: string) => `Please enter the ${field}`,
  },
  fields: {
    email: "Email",
    password: "Password",
    role: "Role",
    spoolId: "Spool ID",
    cadFile: "CAD File",
    pleaseSelectAt: "Please select at least one Material",
    firstName: "First Name",
    lastName: " Last Name",
    phoneNumber: "Phone Number",
    personalEmail: "Personal Email",
    city: "City",
    zipcode: "Zipcode",
    country: "Country",
    status: "Status",
    address: "Address",
    notes: "Notes/Description",
    materialName: "Material Name",
    size: "Size",
    quantity: "Quantity",
    description: "Description",
  },
  sideBar: {
    dashboard: "Dashboard",
    estimators: "Estimators",
    detailers: "Detailers",
    users: "Users",
    projects: "Projects",
    purchaser: "Purchaser",
    inventory: "Inventory",
    estimatorsList: "Estimators List",
    projectsList: "Projects List",
    estimatedList: "Estimated List",
    assignedSpool: "Assigned Spool",
    fabricationShop: "Fabrication Shop",
    scanAndInstall: "Scan & Install",
    shipmentAndReceiving: "Shipment & Receiving",
    installationReports: "Installation Reports",
  },
  loginScreen: {
    login: "Login",
    welcome: " Welcome!",
    loginInYourAccount: "Login to your Account",
    role: "Role",
    emailAddress: "Email Address",
    password: "Password",
    forgotPassword: "Forgot Password",
  },
  forgotPasswordScreen: {
    forgotPassword: "Forgot Password",
    returnToLogin: "Return to Login",
    resetPassword: "Reset Password",
    emailAddress: "Email Address",
    enterEmail: "Enter Email to change your password",
  },
  resetPasswordScreen: {
    save: "Save",
    confirmNewPassword: "Confirm New Password",
    newPassword: "New Password",
    resetPassword: "Reset Password",
    yourNewPassword:
      "Your new password must be different from previous used passwords.",
    passwordDoNotMatch: "Passwords do not match.",
  },
  estimator: {
    estimatorManagement: "Estimator Management",
    viewAndManage: "View and manage all estimators in the system.",
    addEstimator: "Add Estimator",
    personalInformation: "  Personal Information",
    projectDetails: "Project Details",
    totalLineNumbers: "Total Line Numbers",
    totalSpoolsCreated: "Total Spools Created",
    generatedQrCodes: "Generated QR Codes",
    reportedIssues: "Reported Issues",
    spoolId: "Spool ID",
    bugs: "Bugs",
  },
  detailer: {
    detailerManagement: "Detailer Management",
    viewAndManage: "View and manage all detailers in the system.",
    addDetailer: "Add Detailer",
    totalAssignedNumbers: "Total Assigned Line Numbers",
    totalSpoolsCreated: "Total Spools Created",
    selectLineNumber: "Select Line Number",
    createSpool: "Create Spool",
    selectAnItem:
      "Select an item from the material request to populate the spool details",
    lineID: "Line ID",
    uploadFile: "Upload File",
    lineId: "Line ID : ",
    spool: "Spool",
    spoolId: "Spool ID",
    addMaterials: "Add Materials",
    qrCode: "QR Code",
    scanThis: "Scan this QR code to access information and record activity",
    generateQr: "Generate QR",
    qrCodeInformation:
      "A QR code will be generated containing the information below.This QR code can be printed and attached to the physical spool for easy identification and tracking.",
    qrCodePreview: "QR Code Preview",
    qrCodeWillBe: "QR code will be generated after confirmation",
    containInformation:
      "This QR code will contain all relevant spool information",
    uploadRevit: "Upload Revit/AutoCAD File",
    pleaseUploadRevit:
      "Please upload the corresponding Revit, AutoCAD file for this spool. This helps us verify the detailing work and ensures accurate linkage with the estimated list.",
    selectSpool: "Select Spool",
    created: "Created",
    generatedQr: "Generated QR Codes",
  },
  projects: {
    projectsManagement: "Projects Management",
    viewAndManage: "View and manage all Projects in the system.",
    addProject: "Add Project",
    pleaseUploadCSVFile:
      "Please upload a clear CSV file  of the Estimator. This helps us verify and link records accurately. Your data is secure and kept private",
    uploadFile: "Upload CSV file of your Estimator ",
    fileUploaded: "File Uploaded",
    yourFileHasBeen: "Your file has been successfully uploaded",
    materialRequestForm: "Material Request Form",
    updateProject: "Update Project",
  },
  dashboard: {
    spoolId: "Spool ID",
    activeProjects: "Active Projects",
    inProgressProject: "In Progress Project",
    completeProjects: "Complete Projects",
    totalFabShop: "Total Fab shop",
    totalEstimator: "Total Estimators",
    totalDetailer: "Total Detailer",
    totalFieldInstaller: "Total Field Installer",
    welcomeToSite:
      " Welcome to SiteTrack — Your Construction Progress Assistant",
    trackSpoolsIssue: "Track spools, issues, installations and more.",
    lineNumber: "Line Number",
    projectOverview: "Project Overview",
    spoolStatus: "Spool Status",
    material: "Material",
    uploadedBy: "Uploaded By",
    lineNumbers: "Line Numbers",
    recentTransaction: "Recent Transaction",
    revenue: "Revenue",
    name: "Name",
    category: "Brand",
    year: "Year",
    price: "Price",
    stock: "Stock",
    action: "Action",
    topPunchedCars: "Top Purchased Cars",
  },
  inventory: {
    inventoryManagement: "Inventory Management",
    viewAndManage: "View and manage all inventory in the system.",
    addInventory: "Add Inventory",
  },
  fabShop: {
    detailed: "Detailed",
    inFabrication: "In-fabrication",
    fabricated: "Fabricated",
    shipped: "Shipped",
    reportIssue: "Report Issue",
    assignWelder: "Assign Welder",
    assigned: "Assigned",
    shipNow: "Ship Now",
    markAsFabricated: "Mark as Fabricated",
    assignAWelderTo:
      'Assign a welder to fabricate this spool. This will mark the spool as "In Fabrication".',
    spool: "Spool : ",
    lineNumber: "Line Number : ",
    reportAnIssueToEstimator: "Report an Issue to Estimator",
    completeFabrication: "Complete fabrication",
    markThisSpool: "Mark this spool as fabricated and ready for shipping.",
    welder: "Welder :",
    completeShipment: "Complete Shipment ",
    completeShipmentReadiness: "Confirm Shipment Readiness",
    confirmYouWant: "Confirm you want to ship this spool",
  },
  fieldInstaller: {
    reportIssue: "Report Issue",
    spoolInput: "Spool Input",
    scanTheQR: "   Scan the QR to view the detail of spool",
    clickToScanQRCode: "  Click to scan QR code",
    qrScannedSuccessfully: "QR Scanned Successfully",
    scanAgain: "Scan Again",
    installationDetail: "Installation Detail",
    captureLocationAndConfirm: " Capture location and confirm installation",
    markAsInstalled: " Mark as Installed",
  },
  fontLanguage: {
    workSans: "Work Sans",
  },
  product: {
    name: "Name",
    phone: "Phone No.",
    carDetails: "Car Details",
    editCarDetails: "Edit Car Details",
    brand: "Brand",
    manufacturingYear: "Manufacturing Year",
    model: "Model",
    transmissionType: "Transmission Type",
    engineType: "Engine Type",
    color: "Color",
    carTraveled: "Car Traveled (KM in thousands)",
    variant: "Variant",
    insurance: "Insurance",
    insuranceAvailable: "Insurance Available",
    insuranceType: "Insurance Type",
    expiryDate: "Expiry Date",
    anyClaimsMade: "Any Claims Made",
    ownershipAndRC: "Ownership & RC",
    usageType: "Usage Type",
    rcAvailable: "RC Available",
    loanHyonthecation: "Loan/Hyonthecation",
    accidentAndServiceHistory: "Accident and Service History",
    accidentHistory: "Accident",
    fullServiceRecord: "Full Service Record",
    carCondition: "Car Condition",
    productImage: "Product Image",
    isAvailableForSell: "Is Available for Sell?",
    assignAgent: "Assign Agent",
  },
  model: {
    modelName: "Brand Name",
  },
};
